import { useAuthStore } from 'shared/store/auth'
import { authenticatedFetch } from 'shared/lib/auth/recovery'
import { getApiBaseUrl } from './core/base-url'

export type UploadType = 'screenshot' | 'lot-photo'

/**
 * Uploads a file to the backend's R2-backed multipart route.
 * `screenshot` -> { key } (private receipt); `lot-photo` -> { key, url } (public).
 */
export async function uploadFile(
	file: File,
	type: UploadType,
): Promise<{ key: string; url?: string }> {
	const token = useAuthStore.getState().token
	const form = new FormData()
	form.append('file', file)

	const res = await authenticatedFetch(`${getApiBaseUrl()}/upload?type=${type}`, {
		method: 'POST',
		// NOTE: do not set Content-Type — the browser adds the multipart boundary.
		headers: token ? { authorization: `Bearer ${token}` } : {},
		body: form,
	})
	if (!res.ok) {
		throw new Error(`Upload failed: ${res.status}`)
	}
	return (await res.json()) as { key: string; url?: string }
}

/** Buyer receipt upload: returns the storage key used when submitting a wallet top-up. */
export async function uploadScreenshot(file: File): Promise<{ key: string }> {
	const { key } = await uploadFile(file, 'screenshot')
	return { key }
}

/** Admin lot-photo upload: key is persisted; URL is used only for preview. */
export async function uploadLotPhoto(
	file: File,
): Promise<{ key: string; url: string }> {
	const { key, url } = await uploadFile(file, 'lot-photo')
	if (!key || !url) throw new Error('Upload did not return a key and public URL')
	return { key, url }
}
